import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33560f6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contentBox" }
const _hoisted_2 = { style: {"font-size":"20px","color":"#000000","line-height":"20px","font-weight":"600","padding-right":"30%"} }
const _hoisted_3 = { style: {"font-size":"12px","color":"#999999","line-height":"20px","font-weight":"400","margin":"10px 0 25px 0"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"width":"100px","text-align":"right"} }, "任务编码 ： ", -1))
const _hoisted_5 = { style: {"background":"#f5f5f5","border":"1px dashed rgba(204, 204, 204, 1)","border-radius":"4px","padding":"25px 25% 25px 20%"} }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  class: "contentBox",
  style: {"margin-top":"20px"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title2" }, "基础信息", -1))
const _hoisted_12 = {
  class: "centerBox",
  style: {"padding":"0 25% 0 20%"}
}
const _hoisted_13 = {
  class: "contentBox",
  style: {"margin-top":"20px"}
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title2" }, "任务内容", -1))
const _hoisted_15 = {
  class: "centerBox",
  style: {"padding":"0 25% 0 20%"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"136px","text-align":"right","font-size":"16px","color":"#000000","line-height":"20px","font-weight":"600","margin-bottom":"20px"} }, " 活动推广信息配置 ", -1))
const _hoisted_17 = {
  key: 0,
  style: {"width":"136px","text-align":"right","font-size":"16px","color":"#000000","line-height":"20px","font-weight":"600","margin":"40px 0 20px"}
}
const _hoisted_18 = { style: {"display":"flex","justify-content":"center","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      class: "taskManagement",
      "label-col": { style: { width: '150px' } }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.formState.taskTitle), 1),
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.formState.taskCode), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_a_form_item, { label: "项目名称" }, {
                default: _withCtx(() => [
                  (_ctx.formState.prjName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.formState.prjName), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_7, "--"))
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "项目编码" }, {
                default: _withCtx(() => [
                  (_ctx.formState.prjCode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.formState.prjCode), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, "--"))
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_a_form_item, { label: "任务类型" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.typeName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "发布人" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.publishName || "--"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "发布时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.publishTime || "--"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "联系人" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.linkName), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "联系电话" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.linkPhone), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "任务执行时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.startTime) + " 至 " + _toDisplayString(_ctx.formState.endTime), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "报名截止时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.getEndTime || "--"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "任务说明" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.taskDescription), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "任务要求" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.taskRequire || "--"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "任务服务费" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.serviceFee), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "备注" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.memo || "--"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "任务执行区域" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.computedtaskDimension(_ctx.formState.taskDimension)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "是否报名审核" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.receiveAudit ? "是" : "否"), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_a_form_item, { label: "子任务说明" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.taskMemo || "--"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "推广URL" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.formState.performUrl || "--"), 1)
              ]),
              _: 1
            }),
            (_ctx.extraList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, " 拓展配置 "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extraList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_component_a_form_item, {
                  label: ' 扩展字段' + (index + 1)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" [ " + _toDisplayString(item.k) + " : " + _toDisplayString(item.v) + " ] ", 1)
                  ]),
                  _: 2
                }, 1032, ["label"])
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_a_button, {
        style: {"width":"80px","height":"40px"},
        onClick: _ctx.cancel
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回 ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
}